import { CNButton } from '@zawarski/eti-ui';
import { Plus } from 'lucide-react';

/** The MUI Fab's resting shadow (elevation 6), kept so the button still floats over the lists. */
const FAB_SHADOW =
  '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)';

/**
 * The floating action button, styled like the dashboard children's create buttons ("NEW
 * SIGEVENT +", "NEW SHELTER +"): a 32px pill in the REP primary blue with an uppercase label and
 * a trailing plus. The button draws its own icon so every page shows the same one. It sits
 * `bottom`/`right` px from the corner of the nearest positioned ancestor.
 */
const Fab = ({
  label,
  onClick,
  bottom,
  right = 16,
}: {
  label: string;
  onClick: () => void;
  bottom: number;
  right?: number;
}) => (
  <CNButton
    type='button'
    className='palmetto-print-hide rep:absolute rep:z-1001 rep:h-8! rep:gap-2! rep:rounded-full! rep:bg-[#2961FD]! rep:px-4! rep:text-sm! rep:font-medium! rep:text-white! rep:uppercase rep:hover:bg-[#1C43B1]!'
    style={{ bottom, right, boxShadow: FAB_SHADOW }}
    onClick={onClick}>
    {label}
    <Plus className='rep:size-5' />
  </CNButton>
);

export default Fab;
